import { makeAutoObservable, runInAction } from "mobx";
export class POrderSummaryCancelled {
    constructor(params) {
        this.type = "Cancelled";
        this.isFinal = true;
        this.reason = params.reason;
        this.confirmationSource = params.confirmationSource;
        this.isOnlinePayment = params.isOnlinePayment;
        this.restaurantPhones = params.restaurantPhones;
        this.retryOrder = params.retryOrder;
        this.paymentRetryAvailable = params.performPaymentRetry !== null;
        this.retryPaymentPending = false;
        if (params.performPaymentRetry !== null &&
            params.onPaymentRetrySuccess !== null) {
            const performPaymentRetry = params.performPaymentRetry;
            const onPaymentRetrySuccess = params.onPaymentRetrySuccess;
            this.retryPayment = async () => {
                console.log("[TYP] Retrying payment...");
                runInAction(() => {
                    this.retryPaymentPending = true;
                });
                const response = await performPaymentRetry();
                runInAction(() => {
                    this.retryPaymentPending = false;
                });
                if (response === null || response.tag === "Errors") {
                    console.log("[TYP] Payment retry failed – falling back to order retry");
                    this.retryOrder();
                }
                else {
                    onPaymentRetrySuccess(response);
                }
            };
        }
        else {
            this.retryPayment = null;
        }
        makeAutoObservable(this);
    }
    setPaymentRetryExpired() {
        console.log("[TYP] Payment retry expired – switching to order retry");
        this.paymentRetryAvailable = false;
        console.log("[TYP] Order retry mode active");
    }
}
